import { render } from "./vue3 scroll.vue?vue&type=template&id=3e55360e"
import script from "./vue3 scroll.vue?vue&type=script&lang=js"
export * from "./vue3 scroll.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\34222\\Desktop\\kuaiyingyong\\vue-deom1\\官网\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__